<template>
<div class="room-point">
    <div class="room-top">
        <el-form  label-width="80px" :inline="true" class="form leader-style-form">
            <el-form-item label="月份">
                <el-date-picker v-model="search_date" type="month" :clearable="false" placeholder="选择月份" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
            <div style="margin-right:10px;">
                <el-button class="leader-common-button" size="medium" @click="query">查询</el-button>
                <el-button class="leader-common-button" size="medium" @click="getExel">导出</el-button
                >
            </div>
        </el-form>
    </div>
    <div class="room-bottom">
        <div class="room-left">
            <me-tree
                ref="myTree"
                :treeData="data"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'room_id'"
                :showCheckbox="true"
                :title="treeTitle"
                :cascadingVar="false"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :defaultCheckKeys="defaultCheckKeys"
                :show-search="false"
                @handleCheckBoxClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <div class="room-right">
            <el-table border height="50%" style="width: 100%;" class="leader-style-table" :data="tableData">
                <el-table-column align="center" label="序号" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="名称" width="150" property="room_name"></el-table-column>
                <el-table-column align="center" label="本期电量(kWh)" width="200" property="b_dl"></el-table-column>
                <el-table-column align="center" label="较上月同比率(%)" width="200" property="dl_tb"></el-table-column>
                <el-table-column align="center" label="本月占比(%)" >
                    <el-table-column align="center" label="尖" property="bj_zb"></el-table-column>
                    <el-table-column align="center" label="峰" property="bf_zb"></el-table-column>
                    <el-table-column align="center" label="平" property="bp_zb"></el-table-column>
                    <el-table-column align="center" label="谷" property="bg_zb"></el-table-column>
                </el-table-column>
                <el-table-column align="center" label="上月月占比(%)" >
                    <el-table-column align="center" label="尖" property="sj_zb"></el-table-column>
                    <el-table-column align="center" label="峰" property="sf_zb"></el-table-column>
                    <el-table-column align="center" label="平" property="sp_zb"></el-table-column>
                    <el-table-column align="center" label="谷" property="sg_zb"></el-table-column>
                </el-table-column>
                <el-table-column align="center" label="功率因数" width="200" property="b_glys"></el-table-column>
                <el-table-column align="center" label="上月功率因数" width="200" property="s_glys"></el-table-column>
                <el-table-column align="center" label="数据查看" width="200" property="an">
                    <template slot-scope="scope">
                        <el-button type="text">
                            <span class="inner-text" @click="queryDetail(scope.row.room_id)">更多</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="room-right-bottom">
                <div class="right-bottom-l">
                    <v-chart :auto-resize="true" :options="yearBar" ref="yearBar" />
                </div>
                <div class="right-bottom-c">
                    <v-chart :auto-resize="true" :options="lBar" ref="lBar" />
                </div>
                <div class="right-bottom-r">
                    <el-table border height="100%" class="leader-style-table" style="width: 100%;" :data="demandData">
                        <el-table-column align="center" label="名称" width="200" property="point_name"></el-table-column>
                        <el-table-column align="center" label="最大需量(kW)" width="200" property="maxdemand"></el-table-column>
                        <el-table-column align="center" label="最大需量发生时间" property="maxdemand_time"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import dayjs from "dayjs";
import * as api from "@/http/api.js";
import Tree from "@/comon/components/tree.vue";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
export default {
    components: {
        "me-tree": Tree
    },
    data() {
        return {
            search_date: dayjs().format('YYYY-MM'),
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "room_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            nodeKey: "room_id",
            treeTitle: "配电室选择",
            tableData:[],
            y_list:[],
            x_list:[1,2,3,4,5,6],
            y_power:[],
            demandData: []
        }
    },
    mounted() {
        this.getRooms();
    },
    methods: {
        getRooms() {
            api.getRooms().then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    this.defaultCheckKeys = ['1'];
                    this.query();
                }
            })
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
        },
        query() {
            let room_ids = this.defaultCheckKeys.join(',') + ',';
            let show_month = this.search_date + '-01';
            
            api.getRoomList({room_ids,show_month}).then(res => {
                if (res && res.error_code === "0") {
                    this.tableData =  res.bus_json;
                    if(res.bus_json.length) {
                        let room_id = res.bus_json[0].room_id
                        this.queryDetail(room_id)
                    }
                }
            })
        },
        queryDetail(room_id) {
            //let room_id = row.room_id;
            let show_month = this.search_date + '-01';
            api.getRoomDetail({room_id, show_month}).then(res => {
                if (res && res.error_code === "0") {
                    this.y_list = res.bus_json.sixList;
                    this.y_power = res.bus_json.dlList;
                    this.demandData = res.bus_json.demandList;
                }
            })
        },
        getExel() {
            let room_ids = this.defaultCheckKeys.join(',') + ',';
            let show_month = this.search_date + '-01';
            api.getRoomExcel({room_ids,show_month}).then(res => {
                if (res) {
                    const content = res;
                    const blob = new Blob([content]);
                    const fileName ='能源分析.xlsx';
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName);
                    } else {
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        let evt = document.createEvent('MouseEvents');
                        evt.initEvent('click', false, false);
                        link.dispatchEvent(evt);
                        document.body.removeChild(link);
                    }
                    this.$message({
                        message: '下载成功！',
                        type: 'success',
                        duration:5000
                    });
                }
            })
        }
    },
    computed: {
        yearBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ['近6个月电量'],
                    textStyle: {
                        color: "#fff"
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.x_list,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位：kWh",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "近6个月电量",
                        type: "bar",
                        data: this.y_list,
                        itemStyle: {
                            color: "#fe7f66"
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                        }
                    }
                ]
            };
            return options;
        },
        lBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ['尖峰平谷电量'],
                    textStyle: {
                        color: "#fff"
                    }
                },
                grid: {
                    show: true,
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: ['尖','峰','平','谷'],
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "单位：kWh",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff"
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "尖峰平谷电量",
                        type: "bar",
                        data: this.y_power,
                        itemStyle: {
                            color: "#fe7f66"
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#fff'
                        }
                    }
                ]
            };
            return options;
        }
    }
};
</script>

<style scoped lang="scss">
.room-point {
    width: 100%;
    height: 100%;
    //border: 1px solid red;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .room-top {
        display: flex;
        box-sizing: border-box;
        .form {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
    }
    .room-bottom {
        display: flex;
        width: 100%;
        height: 100%;
        .room-left {
            //flex: 1;
        }
        .room-right {
            //flex: 1;
            width: 100%;
            height: 100%;
            overflow: auto;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            //padding-right: 10px;
            //border: 1px solid red;
            //overflow-y: auto;
            .room-right-bottom {
                //border: 1px solid red;
                display: flex;
                padding-top: 10px;
                height: 50%;
                width: 100%;
                .right-bottom-l {
                    width: 33%;
                    .echarts {
                        width: 100%;
                        height: 100%;
                    }
                }
                .right-bottom-c {
                    width: 33%;
                    .echarts {
                        width: 100%;
                        height: 100%;
                    }
                }
                .right-bottom-r {
                    width: 33%;
                    .echarts {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
}
</style>